import { Message, toaster } from "rsuite";
import { ApiResponseContainer } from '../../models/api/apiResponseContainer';

export const showErrorToast = (message: string ) => {
  return toaster.push(
    <Message showIcon type="error" duration={5000}>
      {message || "Something went wrong! Please try again later!"}
    </Message>,
    { placement: "bottomEnd" }
  );
};

export const showErrorMessageToast = (error: ApiResponseContainer<any>) => {
  toaster.push(
    <Message showIcon type="error" duration={5000}>
      {error.Message || error.StatusCode || "Something went wrong"}
    </Message>,
    { placement: "bottomEnd" }
  );
  return error;
};

export const showSuccessToast = (message: string) => {
  return toaster.push(
    <Message showIcon type="success" duration={5000}>
      {message}
    </Message>,
    { placement: "bottomEnd" }
  );
};
